import type { Preferences } from '../model/schema';
import { PREFS_CACHE_KEY } from '../model/schema';
import { deriveBrandScale } from './accentColor';
import { fontStackOf, type FontChoice } from './fontFamily';

export type ResolvedTheme = 'light' | 'dark';

export function resolveTheme(theme: Preferences['theme']): ResolvedTheme {
  if (theme === 'system') return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  return theme;
}

/**
 * Tercihleri DOM'a uygular (tema, yoğunluk, yazı ölçeği/ailesi, vurgu rengi, dil) ve
 * cache'e yazar. Değerler CSS değişkenlerine yazılır; bileşenler yalnızca token okur,
 * bu yüzden tercih değişince yeniden render gerekmez.
 */
export function applyPrefs(p: Preferences) {
  const html = document.documentElement;
  html.dataset['theme'] = resolveTheme(p.theme);
  html.dataset['density'] = p.density;
  html.style.setProperty('--font-scale', String(p.fontScale));
  html.style.setProperty('--font-family-base', fontStackOf(p.fontFamily as FontChoice));

  // Marka tonları tek bir vurgu renginden türetilir; odak halkası da aynı renge bağlı
  // kalmalı, yoksa düğme yeşil odak halkası mavi gibi tutarsızlıklar çıkıyor.
  const scale = deriveBrandScale(p.accentColor);
  html.style.setProperty('--brand-400', scale[400]);
  html.style.setProperty('--brand-500', scale[500]);
  html.style.setProperty('--brand-600', scale[600]);
  html.style.setProperty('--brand-700', scale[700]);
  html.style.setProperty('--ring', scale[500]);

  html.lang = p.language.slice(0, 2);
  try {
    localStorage.setItem(PREFS_CACHE_KEY, JSON.stringify(p));
  } catch {
    /* noop */
  }
}

export function readCachedPrefs(): unknown {
  try {
    const raw = localStorage.getItem(PREFS_CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
